import { Injectable } from "@angular/core";

import { HttpService } from "./http.service";
import { ADMIN_API_ENDPOINTS } from "@api/common/api-endpoints";
import { NotificationTemplateDto } from "@api/dto/governance-admin/offline-tenant-voucher.dto";

@Injectable()
export class AdminNotificationTemplateService {
  constructor(private httpService: HttpService) {}

  async find(): Promise<NotificationTemplateDto[]> {
    return await this.httpService.get<NotificationTemplateDto[]>(
      ADMIN_API_ENDPOINTS.NOTIFICATION_TEMPLATES
    );
  }
}
